<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/">展覽列表</a><span>/</span>
          <em name="Exhibition"></em> <span>/</span>官方行銷活動
        </div>
        <div>
          <span class="bold">登入帳號 :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <article>
      <div class="MbDevice">
        <div class="homeLeft">
          <div class="UserAccount ml-1">
            <span class="bold">登入帳號 :</span>
            <span> {{ UserId }}</span>
          </div>
          <hr />
          <div class="expoLogo"><img :src="ExhLogo" width="100%" /></div>
          <div class="expoInfo">
            <p class="bold" name="Exhibition"></p>
            <p>{{ ExhBegin }} - {{ ExhEnd }}</p>
            <p>{{ ExhVenue }}</p>
          </div>
          <p class="clear"></p>
        </div>
      </div>
      <div class="contentBox">
        <h1>官方行銷活動</h1>

        <div class="mt-5">
          <div v-html="RegistrationInfo"></div>
        </div>

        <p class="clear"></p>

        <!-- <div class="row mt-5">
          <div
            v-for="item in campaignList"
            :key="item.eventID"
            class="col-md-4 border p-4 mb-3 card-campaign mr-md-3 mr-0"
          >
            <h3 style="font-weight: 500">{{ item.EventName }}</h3>

            <div class="mt-3 ellipsis2">
              {{ item.EventSummary }}
            </div>

            <div class="text-right btn-wrapper">
              <div
                class="btn btn-primary"
                @click="toCampaignDetail(item.EventID, item.EventType)"
                v-if="!item.IsRegistered"
              >
                我要報名
              </div>
              <div
                class="btn btn-primary"
                @click="toCampaignDetail(item.EventID, item.EventType)"
                v-else-if="item.IsRegistered"
              >
                編輯報名資料
              </div>
            </div>
          </div>
        </div> -->

        <div class="row mt-5">
          <div
            v-for="(item, index) in campaignList"
            :key="item.eventID"
            class="col-md-4 mb-4"
          >
            <div
              class="card-campaign p-4 h-100 d-flex flex-column justify-content-between"
              :style="{
                backgroundColor: index % 2 === 0 ? '#e9e9e9' : '#f5f5f5',
              }"
              e9e9e9cf
            >
              <div>
                <h3
                  style="
                    font-weight: 700;
                    font-size: 1.5rem;
                    letter-spacing: 1px;
                  "
                >
                  {{ item.EventName }}
                </h3>

                <div
                  class="mt-3 ellipsis2 text-secondary"
                  v-html="item.EventSummary"
                ></div>
              </div>

              <div class="text-right mt-4">
                <button
                  class="btn btn-dark px-3"
                  style="background-color: #333; border: none"
                  @click="toCampaignDetail(item.EventID, item.EventType)"
                >
                  {{ item.IsRegistered ? "編輯報名資料" : "我要報名" }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-5">
          <div v-html="ContactInfo"></div>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  components: {},

  metaInfo() {
    return {
      title: "官方行銷活動 - 展昭參展商管理系統",
    };
  },

  data() {
    return {
      UserId: "",
      RegNo: "",

      ExhLogo: "",
      ExhBegin: "",
      ExhEnd: "",
      ExhVenue: "",
      eExhVenue: "",
      campaignList: [],
      ContactInfo: "",
      RegistrationInfo: "",
    };
  },

  methods: {
    toCampaignDetail(eventID, eventType) {
      document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/campaignDetail?no=${this.RegNo}&eventId=${eventID}&eventType=${eventType}`;
    },
  },

  created() {
    const vm = this;

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //url取出展碼
    let nowPage = location.href;
    vm.RegNo = nowPage.split("no=")[1];

    let lang = "tw";

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${lang}`,
      )
      .then((response) => {
        vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`;
        vm.ExhBegin = response.data.Data.ExhBegin;
        vm.ExhEnd = response.data.Data.ExhEnd;
        vm.ExhVenue = response.data.Data.ExhVenue;
        vm.eExhVenue = response.data.Data.eExhVenue;
      });
    axios
      .get(
        `https://www.chanchao.com.tw/ApiMarketingCampaign/MarketingEvents/${vm.RegNo}?lang=tw`,
      )
      .then((response) => {
        vm.campaignList = response.data.Data;
      });

    axios
      .get(
        `https://www.chanchao.com.tw/ApiMarketingCampaign/Exhibitor/ContactInfo/${vm.RegNo}?lang=tw`,
      )
      .then((response) => {
        vm.ContactInfo = response.data.Data.ContactDetail;
      });

    axios
      .get(
        `https://www.chanchao.com.tw/ApiMarketingCampaign/Exhibitor/RegistrationInfo/${vm.RegNo}?lang=tw`,
      )
      .then((response) => {
        vm.RegistrationInfo = response.data.Data.RegDetail;
      });
  },
};
</script>

<style lang="scss">
@import "./../../../assets/helper/table.css";
@import "./../../../assets/helper/fancybox.css";

@media (min-width: 768px) {
  .col-md-4 {
    flex: 0 0 30.333333%;
    max-width: 33.3333333333%;
  }
}

/* 標題超出設定... */
.ellipsis2 {
  display: -webkit-box;
  -webkit-line-clamp: 3; /* 顯示三行 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis; /* 超出顯示 ... */
  white-space: normal; /* 確保文字可以換行 */
  word-break: break-all; /* 預防長英文網址或單字撐開容器 */
}

.card-campaign {
  position: relative; /* 必須設定，讓按鈕能以這格為基準定位 */
  height: 210px; /* 設定你想要的固定高度 */
  transition: transform 0.2s;
}

/* 奇數項 (1, 3, 5...): 深灰色 */
// .card-campaign:nth-child(odd) {
//   background-color: #e0e0e0; /* 這裡填入你想要的深灰色 */
// }

// /* 偶數項 (2, 4, 6...): 淺灰色 */
// .card-campaign:nth-child(even) {
//   background-color: #f5f5f5; /* 這裡填入你想要的淺灰色 */
// }

.btn-wrapper {
  position: absolute; /* 絕對定位 */
  bottom: 10px; /* 距離底部剛好 7px */
  right: 20px; /* 距離右邊一點距離，配合你的 p-4 */
  width: calc(
    100% - 40px
  ); /* 讓容器寬度扣掉兩邊 Padding，確保 text-right 生效 */
}

.contact-box * {
  all: revert !important;
  box-sizing: border-box !important;
}
</style>
